export const termsAndConditionsUrl = (currentIsoCountry: string) => {
  switch (currentIsoCountry) {
    case 'br':
      return 'https://factorialhr.com.br/termos-e-condicoes-programa-de-indicacoes'
    default:
      return 'https://factorialhr.com/terms-and-conditions-referral-program'
  }
}

export const companySize = (step: string) => {
  switch (step) {
    case '1':
      return '15-30'
    case '2':
      return '31-50'
    case '3':
      return '51-150'
    case '4':
      return '+150'
  }
}

export const reward = (currentIsoCountry: string, step: string) => {
  switch (currentIsoCountry) {
    case 'ar':
    case 'bo':
    case 'bs':
    case 'bz':
    case 'cl':
    case 'co':
    case 'cr':
    case 'do':
    case 'ec':
    case 'gt':
    case 'hn':
    case 'jm':
    case 'ky':
    case 'mx':
    case 'ni':
    case 'pa':
    case 'pe':
    case 'pr':
    case 'py':
    case 'sv':
    case 'uy':
    case 've':
      return { 1: 'MX$ 5000', 2: 'MX$ 9000', 3: 'MX$ 15000', 4: 'MX$ 50000' }[step]
    case 'us':
      return { 1: '$300', 2: '$700', 3: '$1200', 4: '$3500' }[step]
    case 'br':
      return { 1: 'R$ 0', 2: 'R$ 2500', 3: 'R$ 5000', 4: 'R$ 10000' }[step]
    case 'gb':
      return { 1: '£300', 2: '£700', 3: '£1200', 4: '£3500' }[step]
    case 'de':
    case 'fr':
      return { 1: '300€', 2: '700€', 3: '1200€', 4: '3500€' }[step]
    case 'it':
    case 'pt':
    case 'es':
      return { 1: '300€', 2: '600€', 3: '1000€', 4: '3000€' }[step]
    default:
      return 0
  }
}

export const isCountryAvailable = (currentIsoCountry: string) => {
  const availableCountries = ['ve', 'br', 'pt', 'it', 'gb', 'us', 'fr', 'de', 'es']
  return availableCountries.includes(currentIsoCountry)
}

type ValidLocale = 'pt-br' | 'pt' | 'it' | 'en-gb' | 'en-us' | 'fr' | 'de' | 'es'

export const referralUrlForLocale = (locale: ValidLocale | string) => {
  switch (locale) {
    case 'de':
      return 'https://factorialhr.de/referral'
    case 'en-gb':
      return 'https://factorialhr.co.uk/referral'
    case 'pt-br':
      return 'https://factorialhr.com.br/referral'
    case 'pt':
      return 'https://factorialhr.pt/referral'
    case 'it':
      return 'https://factorial.it/referral'
    case 'fr':
      return 'https://factorialhr.fr/referral'
    case 'es':
      return 'https://factorialhr.es/referral'
    case 'es-mx':
      return 'https://factorial.mx/referral'
    case 'en-us':
    default:
      return 'https://factorialhr.com/referral'
  }
}

export const card_reward = (currentIsoCountry: string) => {
  switch (currentIsoCountry) {
    case 'mx':
      return 'MX$ 4330'
    case 'us':
      return '$220'
    case 'br':
      return 'R$ 700'
    case 'gb':
      return '£200'
    default:
      return '200€'
  }
}
